module.exports = __webpack_public_path__ + "img/2_deal_maker.fd91ebc2.png";